import { useState } from "react";
import { Switch } from "@/components/ui/switch";
import {
  AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription,
  AlertDialogFooter, AlertDialogHeader, AlertDialogTitle,
} from "@/components/ui/alert-dialog";

// Turning ON asks for one confirmation; turning OFF is immediate.
export const ConfirmSwitch = ({ id, checked, disabled, onOn, onOff, title, body, confirmLabel, tone = "red", label }) => {
  const [ask, setAsk] = useState(false);
  const color = tone === "amber" ? "data-[state=checked]:bg-amber-500" : "data-[state=checked]:bg-red-600";
  return (
    <>
      <label className={`flex items-center gap-3 ${disabled ? "cursor-not-allowed opacity-50" : "cursor-pointer"}`}>
        <Switch data-testid={id} checked={checked} disabled={disabled} className={color}
          onCheckedChange={(v) => (v ? setAsk(true) : onOff())} />
        <span className="text-xs font-semibold tracking-wide text-slate-200">{label}</span>
      </label>
      <AlertDialog open={ask} onOpenChange={setAsk}>
        <AlertDialogContent className={`z-[60] bg-[#121826] text-slate-100 ${tone === "amber" ? "border-amber-500/40" : "border-red-500/40"}`}>
          <AlertDialogHeader>
            <AlertDialogTitle className={tone === "amber" ? "text-amber-300" : "text-red-400"}>{title}</AlertDialogTitle>
            <AlertDialogDescription className="text-slate-300">{body}</AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter>
            <AlertDialogCancel data-testid={`${id}-cancel`}>Cancel</AlertDialogCancel>
            <AlertDialogAction data-testid={`${id}-confirm`} onClick={onOn} className={tone === "amber" ? "bg-amber-600 hover:bg-amber-500" : "bg-red-600 hover:bg-red-500"}>{confirmLabel}</AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </>
  );
};
